import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-text-dialog',
  templateUrl: './text-dialog.component.html',
  styleUrl: './text-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class TextDialogComponent {
  dialogRef = inject<MatDialogRef<TextDialogComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    body: string;
    dialog_close_button: string;
  }>(MAT_DIALOG_DATA);

  close() {
    this.dialogRef.close();
  }
}
